<label soho-label [attr.for]="id">{{fieldLabel}}</label>
<!-- showAlert is set for structures dialog if there is a reporting basis-->
@if (showAlert) {
  @if (!immutable) {
    <input type="text"
      [attr.id]="id"
      [attr.data-automation-id]="automationId"
      [(ngModel)]="lookupValue"
      (ngModelChange)="onNgModelChange($event)"
      soho-alert
      soho-lookup
      [click]="onLookupClick"
      [field]="onLookupField"
      soho-busyindicator
      blockUI="true"
      displayDelay="0"
      (change)="onValueChanged($event)"
      />
  }
  @if (immutable) {
    <p
      [attr.id]="id"
      class="lm-text-data hide-white-space"
      [ngStyle]="{'display': 'inline-block'}"
      [class.data]="true"
    >{{lookupValue}}</p>
  }
} @else {
  @if (!immutable) {
    <input type="text"
      [attr.id]="id"
      [attr.data-automation-id]="automationId"
      [(ngModel)]="lookupValue"
      (ngModelChange)="onNgModelChange($event)"
      soho-trackdirty
      soho-lookup
      [click]="onLookupClick"
      [field]="onLookupField"
      soho-busyindicator
      blockUI="true"
      displayDelay="0"
      (change)="onValueChanged($event)"
      />
  }
  @if (immutable) {
    <p
      [attr.id]="id"
      class="lm-text-data hide-white-space"
      [ngStyle]="{'display': 'inline-block'}"
      [class.data]="true"
    >{{lookupValue}}</p>
  }
}
<!-- All other cases -->
<div #lookupBasicPlaceholder id="lookupBasicPlaceholder"></div>
